const formSelector = 'form[data-formie-form], div[data-formie-form]'
const startupScriptSelector = 'script[data-formie-startup][src]'
const translationsSelector =
    'script[type="application/json"][data-formie-translations]'

let formieScriptPromise = null

const getForms = (scope = document) => {
    return Array.from(scope.querySelectorAll(formSelector))
}

const getHtmlDocument = (html = '') => {
    const template = document.createElement('template')
    template.innerHTML = html

    return template.content
}

// Formie 4 reads its front-end strings from an inline JSON block. Barba only swaps the
// page container, so a block that was rendered outside it has to be carried over.
const adoptFormieTranslations = (html = '') => {
    if (!html || document.querySelector(translationsSelector)) {
        return
    }

    const incoming = getHtmlDocument(html).querySelector(translationsSelector)

    if (!incoming) {
        return
    }

    const script = document.createElement('script')

    script.type = 'application/json'
    script.setAttribute('data-formie-translations', '')
    script.textContent = incoming.textContent

    document.head.appendChild(script)
}

// Formie 4 ships as an ES module that boots itself and then watches the document with a
// MutationObserver, so forms that Barba injects later are mounted automatically. The only
// thing we have to do is make sure the module is on the page at all — Formie only registers
// its assets on pages that actually render a form, so arriving from a form-less page means
// the module was never loaded.
const loadFormieScript = (html = '') => {
    if (document.querySelector(startupScriptSelector)) {
        return Promise.resolve(true)
    }

    if (formieScriptPromise) {
        return formieScriptPromise
    }

    const incoming = getHtmlDocument(html).querySelector(startupScriptSelector)
    const src = incoming?.getAttribute('src')

    if (!src) {
        return Promise.resolve(false)
    }

    formieScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script')

        script.type = 'module'
        script.src = src
        script.setAttribute('data-formie-startup', '')
        script.onload = () => resolve(true)
        script.onerror = reject

        document.head.appendChild(script)
    })

    return formieScriptPromise
}

export const initFormieAfterBarba = async (scope = document, html = '') => {
    const forms = getForms(scope)

    if (!forms.length) {
        return false
    }

    adoptFormieTranslations(html)

    return loadFormieScript(html)
}
